export enum MaritalStatus {
    MARRIED = "C",
    DIVORCED = "D",
    SINGLE = "S",
    WIDOWER = "V"
}